import React from 'react';
import { Typography } from 'ui-lib';
import css from '../raptor-components.css';

export interface ISupportedPlatformSummaryItem {
    key: string;
    label: React.ReactNode;
}

interface ISupportedPlatformsSummaryProps {
    items: ISupportedPlatformSummaryItem[];
    emptyText?: string;
}

export const SupportedPlatformsSummary = (props: ISupportedPlatformsSummaryProps): JSX.Element => {
    if (props.items.length === 0) {
        return (
            <Typography.Text type='secondary'>{props.emptyText || 'No supported platforms selected.'}</Typography.Text>
        );
    }

    return (
        <React.Fragment>
            <Typography.Title level={5}>Supported platforms</Typography.Title>
            <div className={css['supported-platform-summary']}>
                {props.items.map((item) => (
                    <div key={item.key} className={css['supported-platform-item']}>
                        {item.label}
                    </div>
                ))}
            </div>
        </React.Fragment>
    );
};
